module.exports = __webpack_public_path__ + "img/canyon.be5030ca.webp";